import { MODAL } from '@constants/Text'

// Resolver de "entrada no Compliance" pela navegação client-centric
// (navegacao-v2) — registrado em @modules/compliance/index.js via
// registerClienteEntranceResolver. A sidebar genérica não conhece nada do
// Compliance, só invoca este resolver pela chave do módulo
// (item.clienteEntranceModule).
//
// Diferente do CRM (que tem lead vs cliente), aqui não há ambiguidade de
// destino: sempre navega para a Visão Geral e abre o modal "Visão geral
// cliente" (compliance-client-overview.vue) — o mesmo modal aberto hoje pelo
// botão de ícone "olho" na tabela. Sem chamada a backend: o modal já busca os
// próprios dados via item.id no seu open()/loadData().
//
// O payload `item` precisa espelhar o que openModalOverview() já manda hoje
// (view-compliance-overview.vue:993-999) — a linha INTEIRA do cliente (fonte:
// global/fullDataClient), não só `{id}`. O título do modal (`title()` em
// compliance-client-overview.vue:96-99) lê `itemData.nome_cliente` direto do
// payload recebido em open() e NUNCA é recalculado a partir dos dados
// carregados depois (clientData) — payload raso = título preso em "Editar
// cliente" para sempre, não só um flash. $currentClient() já tem os mesmos
// campos denormalizados (nome_cliente incluso), então espalhar o objeto
// inteiro resolve sem precisar buscar nada a mais.
const ROUTE_NAME = 'compliance.overview'

/**
 * Síncrono (sem `async`): quem consome (resolveModuleEntranceCliente) faz
 * `await` no retorno de qualquer jeito, então funciona igual a uma promise.
 * Sem `async` aqui porque não há nada pra esperar — evita o lint
 * require-await por uma função sem nenhum await interno.
 *
 * @param {Object} ctx
 * @param {Object} ctx.client cliente ativo ($currentClient())
 * @returns {{routeName: string, modal: {name: string, payload: Object}}}
 */
export function resolveComplianceClienteEntrance({ client } = {}) {
  const idClienteApp = client && client.id

  return {
    routeName: ROUTE_NAME,
    modal: {
      name: MODAL.COMPLIANCE_CLIENT_OVERVIEW,
      payload: { item: { ...client, id: idClienteApp }, optionView: 'overview' },
    },
  }
}
